import { db, storage } from "../firebase";

const sanitizeFileName = (name) => {
  const base = String(name || "headshot").split(/[/\\]/).pop();
  const cleaned = base.replace(/[^a-zA-Z0-9._-]/g, "_");
  return cleaned || "headshot";
};

/** Unique per-player storage path to avoid filename collisions across profiles. */
export const buildHeadshotStoragePath = (docID, fileName) => {
  return `profile-headshots/${docID}/${Date.now()}-${sanitizeFileName(fileName)}`;
};

/**
 * Upload a headshot file to Firebase Storage.
 * @returns {Promise<string>} download URL
 */
export const uploadPlayerHeadshot = (file, docID) => {
  if (!file || typeof file !== "object") {
    return Promise.reject(new Error("Invalid headshot file"));
  }
  const storagePath = buildHeadshotStoragePath(docID, file.name);
  const storageRef = storage.ref(storagePath);
  const uploadTask = storageRef.put(file);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      null,
      reject,
      () => {
        storageRef.getDownloadURL().then(resolve).catch(reject);
      }
    );
  });
};

/** Persist headshot download URL on the player profile document. */
export const savePlayerHeadshotUrl = (docID, downloadURL) =>
  db.collection("player-profile").doc(docID).update({
    ID: docID,
    Headshot: downloadURL,
  });

/**
 * Upload and save headshot for a player profile.
 * @returns {Promise<string>} download URL
 */
export const uploadAndSavePlayerHeadshot = async (file, docID) => {
  const downloadURL = await uploadPlayerHeadshot(file, docID);
  await savePlayerHeadshotUrl(docID, downloadURL);
  return downloadURL;
};

/** Normalize dropzone value to a single File, if present. */
export const normalizeHeadshotFile = (value) => {
  if (!value) return null;
  if (value instanceof File) return value;
  if (Array.isArray(value) && value[0] instanceof File) return value[0];
  return null;
};
